import { render, staticRenderFns } from "./NguonTinTucForm.vue?vue&type=template&id=773681ce"
import script from "./NguonTinTucForm.vue?vue&type=script&lang=js"
export * from "./NguonTinTucForm.vue?vue&type=script&lang=js"
import style0 from "./NguonTinTucForm.vue?vue&type=style&index=0&id=773681ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports